import { ReactNode, useEffect, useRef } from 'react';
import { useDocsQuery } from 'src/pages/dashboard/DocsPage';
import { type DocItemsStoreApi, docItemsFactory } from './factory';
import { DocItemsContext } from './hooks/useDocItemsContext';

export function DocsStoreProvider({ children }: { children: ReactNode }) {
  const storeRef = useRef<DocItemsStoreApi | null>(null);

  if (!storeRef.current) {
    storeRef.current = docItemsFactory();
  }

  const { docs: fetchedDocs, isDocsLoading } = useDocsQuery();

  useEffect(() => {
    if (!isDocsLoading && fetchedDocs) {
      storeRef.current!.getState().syncDocs(fetchedDocs);
    }
  }, [isDocsLoading, fetchedDocs]);

  return (
    <DocItemsContext.Provider value={storeRef.current!}>
      {children}
    </DocItemsContext.Provider>
  );
}
